<form [formGroup]="toolbarForm">
  <div class="row entry-row submenu-row">
    <div class="col-auto">
      <h1 class="content-header-title">
        {{ '::Users' | abpLocalization }}
      </h1>
    </div>
    <div class="col-md-auto pl-md-0">
      <abp-breadcrumb></abp-breadcrumb>
    </div>
    <div class="col">
      <div class="text-lg-right pt-2 ca-toolbar" id="AbpContentToolbar">
        <div class="ca-toolbar-west-section">
          <div class="toolbar-item first">
            <button
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
              type="button"
              (click)="addNew()">
              <i class="far fa-plus-circle"></i>
              <span>{{ '::AddNew' | abpLocalization }}</span>
            </button>
          </div>
          <div class="toolbar-item">
            <button
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
              type="button"
              *ngIf="canExport"
              (click)="exportUsers($event)">
              <i class="far fa-file-excel"></i>
              <span>{{ '::Export' | abpLocalization }}</span>
            </button>
          </div>
          <div class="toolbar-item">
            <button
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
              type="button"
              (click)="importFromFile($event)">
              <i class="far fa-file-import"></i>
              <span>{{ '::Import' | abpLocalization }}</span>
            </button>
          </div>
          <div
            class="toolbar-item last"
            ngbDropdown
            role="group"
            container="body"
            [ngbTooltip]="'User::SelectUserToUpdate' | abpLocalization"
            [disableTooltip]="selectedCount > 0"
            [dropdownClass]="'ca-popup-dropdown-menu'">
            <button
              [disabled]="selectedCount == 0"
              type="button"
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button dropdown-toggle-split"
              ngbDropdownToggle>
              <i class="far fa-sync"></i>
              <span>
                {{ 'User::Update' | abpLocalization }}
                {{ selectedCount > 0 ? '(' + selectedCount + ')' : '' }}
              </span>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <ca-user-batch-update-department
                [cls]="'dropdown-item'"
                [selection]="selection"
                (refreshRequested)="refresh()"></ca-user-batch-update-department>
              <ca-user-batch-update-role
                [cls]="'dropdown-item'"
                [selection]="selection"
                (refreshRequested)="refresh()"></ca-user-batch-update-role>
            </div>
          </div>
        </div>
        <div class="ca-toolbar-east-section">
          <div class="toolbar-item last">
            <mat-slide-toggle
              labelPosition="before"
              (change)="onIncludePassiveUsersChange()"
              formControlName="includePassiveUsers">
              {{ '::IncludePassives' | abpLocalization }}
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
